var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("article", { staticClass: "nti-demo-component" }, [
    _vm._v("\n    " + _vm._s(_vm.demotitle) + "\n    "),
    _c("p", [_vm._v(_vm._s(_vm.demovalue))]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }